import { render, staticRenderFns } from "./MultiLang.vue?vue&type=template&id=5b62f39e"
import script from "./MultiLang.vue?vue&type=script&lang=js"
export * from "./MultiLang.vue?vue&type=script&lang=js"
import style0 from "./MultiLang.vue?vue&type=style&index=0&id=5b62f39e&prod&lang=css"
import style1 from "./MultiLang.vue?vue&type=style&index=1&id=5b62f39e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports